import React from "react";
import { Box, Card, Typography } from "@mui/material";
import AccountBalanceWalletRoundedIcon from "@mui/icons-material/AccountBalanceWalletRounded";
import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";
import EventRepeatRoundedIcon from "@mui/icons-material/EventRepeatRounded";
import VerifiedRoundedIcon from "@mui/icons-material/VerifiedRounded";

const cards = [
  {
    id: "toPay",
    label: "Total de plata",
    key: "toPay",
    accent: "#06b6d4",
    icon: AccountBalanceWalletRoundedIcon,
  },
  {
    id: "overdue",
    label: "Restante",
    key: "overdue",
    accent: "#fb7185",
    icon: WarningAmberRoundedIcon,
  },
  {
    id: "dueSoon",
    label: "Scadente in 7 zile",
    key: "dueSoon",
    accent: "#f59e0b",
    icon: EventRepeatRoundedIcon,
  },
  {
    id: "paid",
    label: "Platite luna aceasta",
    key: "paid",
    accent: "#22c55e",
    icon: VerifiedRoundedIcon,
  },
];

const money = (n) =>
  new Intl.NumberFormat("ro-RO", {
    style: "currency",
    currency: "RON",
    minimumFractionDigits: 2,
  }).format(Number(n || 0));

function KpiCards({ summary = {} }) {
  return (
    <Box className="sf-kpi-grid">
      {cards.map((card) => (
        <Card key={card.id} className="sf-kpi-card" sx={{ "--sf-accent": card.accent }}>
          <Box className="sf-kpi-head">
            <Typography className="sf-kpi-label">{card.label}</Typography>
            <card.icon className="sf-kpi-icon" />
          </Box>
          <Typography className="sf-kpi-value">{money(summary?.[card.key])}</Typography>
        </Card>
      ))}
    </Box>
  );
}

export default KpiCards;
